"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const MatchRoad_1 = __importDefault(require("@Components/MatchComponents/MatchRoad"));
const react_1 = __importDefault(require("react"));
const MatchWorkSelectionHeader = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("p", null, "In this step, you will locate the work you'd like to match with your selected sound recording(s)."),
    react_1.default.createElement("p", null, "Two criteria are required to search. If you do not have The MLC Song Code, click the down arrow to select another search criteria."),
    react_1.default.createElement("p", null,
        "To expand full details for the work, click the blue plus sign (",
        react_1.default.createElement("strong", null, "+"),
        "). To select a work, click",
        react_1.default.createElement("strong", null, " Select.")),
    react_1.default.createElement(MatchRoad_1.default, { step: 1 })));
exports.default = MatchWorkSelectionHeader;
